import { useState, useEffect } from 'react';
import { loadMonsterMapping } from '../utils/monsterMapping';

export function useMonsterMapping(tab: string) {
  const [monsterMapping, setMonsterMapping] = useState<any>({});
  useEffect(() => {
    // 공속 탭도 몹 표가 필요하다 — 몹을 고를 때 기본속을 여기서 읽는다
    if (tab === 'admin' || tab === 'battle' || tab === 'speed') {
      loadMonsterMapping()
        .then(data => setMonsterMapping(data));
    }
  }, [tab]);
  return { monsterMapping, setMonsterMapping };
} 